// src/pages/dashboard/TalentDashboardLayout.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HeaderComponent from '../../../components/HeaderComponent';

import CastingDirectorProfilePage from './CastingDirectorProfilePage';
import CastingDirectorDashboard from './CastingDirectorDashboard';
import CastingDirectorSidebar from './CastingDirectorSidebar';
import ManageProjectsPage from '../../projects/ManageProjectsPage';
import PostProjectsPage from '../../projects/PostProjectsPage';
import ManageRolesPage from '../../roles/ManageRolesPage'; 
import PostRolesPage from '../../roles/AddEditRolePage'; 
import ChangePasswordPage from '../ChangePasswordPage';
import TransactionHistoryPage from '../TransactionHistoryPage';
import ManageApplicationsPage from '../directorproducer/ManageApplicationsPage';
import ManageApplicationList from '../../roles/ManageApplicationList';
import ManageApplicationDetails from '../../roles/ManageApplicationDetails';
import CastingTestimonials from '../../roles/CastingTestimonials';

import './CastingDirectorDashboardLayout.css'; 
import FooterComponent from '../../../components/FooterComponent';

const CastingDashboardLayout = () => {
    return (
        <div className="crcd-dashboard-layout min-vh-100 flex flex-column">
            <HeaderComponent />

         
            <div className="dashboard-body flex flex-grow-1">
                <CastingDirectorSidebar/> 
                <main className="dashboard-main-content flex-grow-1 overflow-y-auto py-4">
                    <Routes>
                            <Route index element={<Navigate to="overview" replace />} /> 
                            <Route path="overview" element={<CastingDirectorDashboard />} />
                            <Route path="profile" element={<CastingDirectorProfilePage />} />
                            <Route path="projects" element={<ManageProjectsPage />} />
                            <Route path="post-projects" element={<PostProjectsPage />} />
                            <Route path="post-projects/:projectId" element={<PostProjectsPage />} /> 
                            <Route path="roles" element={<ManageRolesPage />} />
                            <Route path="post-roles" element={<PostRolesPage />} />
                            <Route path="post-roles/:id" element={<PostRolesPage />} /> 
                            <Route path="ChangePasswordPage" element={<ChangePasswordPage />} />
                            <Route path="transaction-history" element={<TransactionHistoryPage />} />
                            <Route path="manage-applications" element={<ManageApplicationList />} />
                            <Route path="manage-applications/:id" element={<ManageApplicationDetails />} />
                            <Route path="casting-testimonials" element={<CastingTestimonials />} />
                        
                    </Routes>
                </main>
            </div>
             <FooterComponent />
        </div>
    );
};

export default CastingDashboardLayout;